import {
  SET_AEM_PROPS_TO_STORE,
} from '../actions';

interface AemPropsState {
  [key: string]: unknown;
}

interface Action {
  type: string;
  payload?: Record<string, unknown>;
}

const initialState: AemPropsState = {};

export const aemProps = (state: AemPropsState = initialState, { type, payload }: Action): AemPropsState => {
  if (type === SET_AEM_PROPS_TO_STORE) {
    return {
      ...state,
      ...payload,
    };
  }

  return state;
};
